// extracted by mini-css-extract-plugin
module.exports = {"productItems":"ProductList_productItems__2PW5r","productList":"ProductList_productList__2JQVb","search":"ProductList_search__FVGkU"};